<template>
  <ul class="sidebar-menu">
    <li class="header" v-if="flag === 'es'">Páginas</li>
    <li class="header" v-else-if="flag === 'de'">Seiten</li>
    <li class="header" v-else-if="flag === 'us'">Pages</li>
    <li class="header" v-else>Páginas</li>
    <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page" v-if="flag === 'es'">Principal</span>
        <span class="page" v-else-if="flag === 'de'">Main</span>
        <span class="page" v-else-if="flag === 'us'">Home</span>
        <span class="page" v-else>Principal</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/manutencao">
      <a>
        <i class="fa ion-android-settings"></i>
        <span class="page" v-if="flag === 'es'">Mantenimiento</span>
        <span class="page" v-else-if="flag === 'de'">Wartung</span>
        <span class="page" v-else-if="flag === 'us'">Maintenance</span>
        <span class="page" v-else>Manutenção</span>
      </a>
    </router-link>
    <li class="treeview">
      <a href="#">
        <i class="fa ion-stats-bars"></i>
        <span class="page" v-if="flag === 'es'">Gráficos</span>
        <span class="page" v-else-if="flag === 'de'">Diagramme</span>
        <span class="page" v-else-if="flag === 'us'">Charts</span>
        <span class="page" v-else>Gráficos</span>
        <span class="pull-right-container">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos">
              <a>
                <span class="page" v-if="flag === 'es'">General</span>
                <span class="page" v-else-if="flag === 'de'">Allgemein</span>
                <span class="page" v-else-if="flag === 'us'">General</span>
                <span class="page" v-else>Gerais</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-material">
              <a>
                <span class="page" v-if="flag === 'es'">Material</span>
                <span class="page" v-else-if="flag === 'de'">Material</span>
                <span class="page" v-else-if="flag === 'us'">Material</span>
                <span class="page" v-else>Material</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-acumulados">
              <a>
                <span class="page" v-if="flag === 'es'">Acumulado por día</span>
                <span class="page" v-else-if="flag === 'de'">Pro Tag akkumuliert</span>
                <span class="page" v-else-if="flag === 'us'">Accumulated per day</span>
                <span class="page" v-else>Acumulados por dia</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
    </li>
   <router-link tag="li" class="pageLink" to="/usuario">
     <a>
       <i class="fa fa-user"></i>
       <span class="page" v-if="flag === 'es'">Usuario</span>
        <span class="page" v-else-if="flag === 'de'">Benutzer</span>
        <span class="page" v-else-if="flag === 'us'">User</span>
        <span class="page" v-else>Usuário</span>
     </a>
   </router-link>
   <router-link tag="li" class="pageLink" to="/logout">
     <a>
       <i class="fa fa-sign-out"></i>
       <span class="page" v-if="flag === 'es'">Cerrar Sesión</span>
        <span class="page" v-else-if="flag === 'de'">Ausloggen</span>
        <span class="page" v-else-if="flag === 'us'">Logout</span>
        <span class="page" v-else>Sair</span>
     </a>
   </router-link>
 </ul>
</template>

<script>
export default {
  name: 'SidebarMenu',
  computed: {
    flag () {
      return this.$store.state.flag
    }
  }
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?4c6a9ae0